<template>
	<el-dialog title="" center :visible="mobile" @close="close">
		<span class="type_size_30 subject_color">绑定手机号</span>
		<div class="p_flex p_logins p_m_t_30 p_f_a">
			<span class="p_m_l_30 type_size_18 ">手机号</span>
			<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="number" maxlength="11" v-model="postData.phone" placeholder="请输入手机号"></el-input></div>
		</div>
		<div class="p_flex p_logins p_f_a p_m_t_30">
			<span class="p_m_l_30 type_size_18 ">验证码</span>
			<div class="p_f_1 p_m_l_30 type_size_18  p_m_r_30"><el-input type="number" maxlength="6" v-model="postData.code" placeholder="请输入验证码"></el-input></div>
			<div class="type_size_18 p_m_r_30 small_hand" :class="[countTimes == true ? 'subject_yellow' : 'yan_code forbid']" @click="verification">
				{{ countTimes == true ? '获取验证码' : seconds + 's后重新获取' }}
			</div>
		</div>
		<div class="p_flex p_f_c p_m_t_30" @click="goButton"><el-button type="success">确认</el-button></div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		mobile: null
	},
	data() {
		return {
			countTime: null,
			countTimes: true,
			seconds: 60,
			postData: { phone:null, code:null },
		};
	},

	mounted() {},
	methods: {
		close() {
			this.$emit('closesm', false);
		},
		goButton() {
			if ( !this.postData.phone || this.postData.phone == '')  return this.$message.error('手机号不能为空');
			if ( !this.postData.code || this.postData.code == '')  return this.$message.error('验证码不能为空');
			this.$request.ajax(this).post('/api/account_binding_phone',this.postData).then(res=>{
				this.$emit('goButtonp', false);
			})
		},
		verification() {
			const thta = this;
			if ( !thta.postData.phone || thta.postData.phone == '') {
				thta.$message.error('手机号不能为空');
				return;
			}
			thta.countTimes = false;
			this.$request.ajax(this).post('api/phone_code',{ phone:this.postData.phone, code_type:'binding_phone' }).then(res=>{
				thta.countDown();
			})
		},
		countDown() {
			const thta = this;
			thta.countTime = setInterval(function() {
				thta.seconds--;
				if (thta.seconds == 0) {
					thta.countTimes = true;
					thta.seconds = 60;
					clearInterval(thta.countTime);
					thta.countTime = null;
					return;
				}
			}, 1000);
		},
	}
};
</script>

<style lang="scss" scoped>
.content_box {
	padding: 20px 0;
}
.subject_red {
	color: #f1282e;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}
.p_logins{
	height: 64px;
	background: #F5F5F5;
	opacity: 1;
	border-radius: 10px;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/user/commponents/mobile.vue